import { getJson } from "./helpers";
import { SEARCH_LINK } from "./config";

// prettier-ignore
const convertor = {0: "۰",1: "۱",2: "۲",3: "۳", 4: "۴",5: "۵", 6: "۶", 7: "۷", 8: "۸", 9: "۹"};

const convertorKeys = Object.keys(convertor);

export const state = {
  searcResults: [],
};

export const loadSearchResults = async function (userInput) {
  try {
    // 1) fetching data
    const data = await getJson(`${SEARCH_LINK}${userInput}`);

    // 2) turns english numbers to farsi
    const matchWord = [...userInput]
      .map((l) => (convertorKeys.includes(l) ? convertor[l] : l))
      .join("");
    console.log(matchWord);

    // 3) filter all results with userinput
    state.searcResults = data.filter((post) => post.title.includes(matchWord));
  } catch (err) {
    throw err;
  }
};
